import { RouteType } from "./config";
import CloseIcon from '@mui/icons-material/Close';
import { Admin } from "../pages/settings/admin/Admin";
import { UserManagement } from "../pages/settings/usermanagement/UserManagement";
import { Users } from "../pages/settings/usermanagement/users/Users";
import { UserRoles } from "../pages/settings/usermanagement/UserRoles";
import { Logs } from "../pages/settings/logs/Logs";
import { AuditLog } from "../pages/settings/logs/AuditLog";
import { EmailsSent } from "../pages/settings/logs/emailsSent/EmailsSent";
import { Suppression } from "../pages/settings/logs/Suppression";
import { SMSSent } from "../pages/settings/logs/SMSSent";
import { ImportHistory } from "../pages/settings/logs/ImportHistory";
import { ExportHistory } from "../pages/settings/logs/ExportHistory";
import { CarRentalPage } from "../pages/settings/carrental/CarRentalPage";
import { AdminDashboard } from "../pages/settings/dashboard/AdminDashboard";
import { AdminCarRental } from "../pages/settings/carrental/AdminCarRental";
import { Seasons } from "../pages/settings/carrental/seasons/Seasons";
import { BlockedDays } from "../pages/settings/carrental/BlockedDays";
import { Rates } from "../pages/settings/carrental/rates/Rates";
import { AddOnCategories } from "../pages/settings/carrental/addOnCategory/AddOnCategories";
import { AdditionalCharges } from "../pages/settings/carrental/additionalCharges/AdditionalCharges";
import { Discounts } from "../pages/settings/carrental/discounts/Discounts";
import { SecurityDeposits } from "../pages/settings/carrental/securityDeposits/SecurityDeposits";
import { EmailTemplates } from "../pages/settings/carrental/emailTemplates/EmailTemplates";
import { RentalAgreement } from "../pages/settings/carrental/rentalAgreement/RentalAgreement";
import { ReturnReceipt } from "../pages/settings/carrental/returnReceipt/ReturnReceipt";
import { AdminFleet } from "../pages/settings/fleet/AdminFleet";
import { FleetSettings } from "../pages/settings/fleet/fleetSettings/FleetSettings";
import { Branches } from "../pages/settings/fleet/branches/Branches";
import { FleetLocations } from "../pages/settings/fleet/fleetLocations/FleetLocations";
import { VehicleClasses } from "../pages/settings/fleet/vehicleClass/VehicleClasses";
import { VehicleTypes } from "../pages/settings/fleet/vehicleTypes/VehicleTypes";
import { VehicleMake } from "../pages/settings/fleet/vehicleMake/VehicleMake";
import { VehicleModel } from "../pages/settings/fleet/vehicleModel/VehicleModel";
import { VehicleEngines } from "../pages/settings/fleet/vehicleEngines/VehicleEngines";
import { Features } from "../pages/settings/fleet/features/Features";
import { AdminContacts } from "../pages/settings/contacts/AdminContacts";
import { PaymentGateways } from "../pages/settings/paymentGateways/PaymentGateways";
import { Settings } from "../pages/settings/paymentGateways/settings/Settings";
import { Gateways } from "../pages/settings/paymentGateways/gateways/Gateways";
import { Transactions } from "../pages/settings/paymentGateways/transactions/Transactions";
import { CreditCards } from "../pages/settings/paymentGateways/creditCards/CreditCards";
import { AdminChecklist } from "../pages/settings/checklist/AdminChecklist";
import { AdminForms } from "../pages/settings/forms/AdminForms";
import { Accounting } from "../pages/settings/accounting/Accounting";
import { Driver } from "../pages/settings/accounting/Driver";
import Billing from "../pages/settings/billing/Billing";
import { Maintenance } from "../pages/settings/fleet/maintenance/Maintenance";
import AccessControl from "../pages/settings/usermanagement/users/accessControl/AccessControl";
import { EmailTemplateTypes } from "../pages/settings/carrental/emailTemplateTypes/EmailTemplateTypes";
import { QuickLinks } from "../pages/settings/dashboard/quickLinks/QuickLinks";
import { WebsiteSettings } from "../pages/settings/admin/websiteSettings/WebsiteSettings";
import { AboutUs } from "../pages/settings/admin/websiteSettings/AboutUs";
import { WebsiteFaq } from "../pages/settings/admin/websiteSettings/websiteFaq/WebsiteFaq";
import { RelocationMapping } from "../pages/settings/fleet/relocationMapping/RelocationMapping";
import VehicleMaintenanceRules from "../pages/settings/fleet/vehicleMaintenanceRules/VehicleMaintenanceRules";

export const appAdminRoutes: RouteType[] = [
  {
    index: true,
    path: "/admin",
    element: <Admin />,
    state: "admin",
    section: "adminsettings",
    sidebarProps: {
      displayText: "Admin",
      icon: 'admin_panel_settings',
    },
  },
  {
    path: "/admin/websitesettings",
    element: <WebsiteSettings />,
    state: "websitesettings",
    sidebarProps: {
      displayText: "Website Settings",
      icon: 'language',
    },
    child: [
      {
        path: "/admin/websitesettings/aboutus",
        element: <AboutUs />,
        state: "websitesettings.aboutus",
        section: "settingsaboutus",
        sidebarProps: {
          displayText: "About Us",
        },
      },
      {
        path: "/admin/websitesettings/faq",
        element: <WebsiteFaq />,
        state: "websitesettings.websitefaq",
        section: "settingswebsitefaq",
        sidebarProps: {
          displayText: "FAQ",
        },
      },
    ],
  },
  {
    path: "/admin/usermanagement",
    element: <UserManagement />,
    state: "usermanagement",
    sidebarProps: {
      displayText: "User management",
      icon: 'manage_accounts',
    },
    child: [
      {
        path: "/admin/usermanagement/users",
        element: <Users />,
        state: "usermanagement.users",
        section: "settingsusers",
        sidebarProps: {
          displayText: "Users",
        },
      },
      {
        path: "/admin/usermanagement/userroles",
        element: <UserRoles />,
        state: "usermanagement.userroles",
        section: "settingsuserroles",
        sidebarProps: {
          displayText: "User Roles",
        },
      },
      {
        path: "/admin/usermanagement/accesscontrol",
        element: <AccessControl />,
        state: "usermanagement.accesscontrol",
        section: "settingsaccesscontrol",
        sidebarProps: {
          displayText: "Access control",
        },
      },
    ],
  },
  {
    path: "/admin/dashboard",
    element: <AdminDashboard />,
    state: "admin.dashboard",
    sidebarProps: {
      displayText: "Dashboard",
      icon: 'dashboard',
    },
    child: [
      {
        path: "/admin/dashboard/quicklinks",
        element: <QuickLinks />,
        state: "admin.dashboard.quicklinks",
        section: "settingsquicklinks",
        sidebarProps: {
          displayText: "Quick Links",
        },
      },
    ],
  },
  {
    path: "/admin/logs",
    element: <Logs />,
    state: "logs",
    sidebarProps: {
      displayText: "Logs",
      icon: 'history',
    },
    child: [
      {
        path: "/admin/logs/auditlog",
        element: <AuditLog />,
        state: "logs.auditlog",
        section: "settingsauditlog",
        sidebarProps: {
          displayText: "Audit Log",
        },
      },
      {
        path: "/admin/logs/emailssent",
        element: <EmailsSent />,
        state: "logs.emailssent",
        section: "settingsemailssent",
        sidebarProps: {
          displayText: "Emails Sent",
        },
      },
      {
        path: "/admin/logs/suppression",
        element: <Suppression />,
        state: "logs.suppression",
        section: "settingssuppression",
        sidebarProps: {
          displayText: "Suppression",
          icon: <CloseIcon sx={{ fontSize: "14px" }} />,
        },
      },
      {
        path: "/admin/logs/smssent",
        element: <SMSSent />,
        state: "logs.smssent",
        section: "settingssmssent",
        sidebarProps: {
          displayText: "SMS Sent",
        },
      },
      {
        path: "/admin/logs/importhistory",
        element: <ImportHistory />,
        state: "logs.importhistory",
        section: "settingsimporthistory",
        sidebarProps: {
          displayText: "Import History",
        },
      },
      {
        path: "/admin/logs/exporthistory",
        element: <ExportHistory />,
        state: "logs.exporthistory",
        section: "settingsexporthistory",
        sidebarProps: {
          displayText: "Export History",
        },
      },
    ],
  },
  {
    path: "/admin/carrental",
    element: <AdminCarRental />,
    state: "carrental",
    sidebarProps: {
      displayText: "Car Rental",
      icon: 'car_rental',
    },
    child: [
      {
        path: "/admin/carrental/carrental",
        element: <CarRentalPage />,
        state: "carrental.carrental",
        section: "settingscarrental",
        sidebarProps: {
          displayText: "Car Rental",
        },
      },
      {
        path: "/admin/carrental/seasons",
        element: <Seasons />,
        state: "carrental.seasons",
        section: "settingsseasons",
        sidebarProps: {
          displayText: "Seasons",
        },
      },
      {
        path: "/admin/carrental/blockeddays",
        element: <BlockedDays />,
        state: "carrental.blockeddays",
        section: "settingsblockeddays",
        sidebarProps: {
          displayText: "Blocked Days",
        },
      },
      {
        path: "/admin/carrental/rates",
        element: <Rates />,
        state: "carrental.rates",
        section: "settingsrates",
        sidebarProps: {
          displayText: "Rates",
        },
      },
      {
        path: "/admin/carrental/addoncategories",
        element: <AddOnCategories />,
        state: "carrental.addoncategories",
        section: "settingsaddoncategories",
        sidebarProps: {
          displayText: "Add-On-Categories",
        },
      },
      {
        path: "/admin/carrental/additionalcharges",
        element: <AdditionalCharges />,
        state: "carrental.additionalcharges",
        section: "settingsadditionalcharges",
        sidebarProps: {
          displayText: "Additional Charges",
        },
      },
      {
        path: "/admin/carrental/discounts",
        element: <Discounts />,
        state: "carrental.discounts",
        section: "settingsdiscounts",
        sidebarProps: {
          displayText: "Discounts",
        },
      },
      {
        path: "/admin/carrental/securitydeposits",
        element: <SecurityDeposits />,
        state: "carrental.securitydeposits",
        section: "settingssecuritydeposits",
        sidebarProps: {
          displayText: "Security Deposits",
        },
      },
      {
        path: "/admin/carrental/emailtemplatetypes",
        element: <EmailTemplateTypes />,
        state: "carrental.emailtemplatetypes",
        section: "settingsemailtemplatetypes",
        sidebarProps: {
          displayText: "Email Template Types",
        },
      },
      {
        path: "/admin/carrental/emailtemplates",
        element: <EmailTemplates />,
        state: "carrental.emailtemplates",
        section: "settingsemailtemplates",
        sidebarProps: {
          displayText: "Email Templates",
        },
      },
      {
        path: "/admin/carrental/rentalagreement",
        element: <RentalAgreement />,
        state: "carrental.rentalagreement",
        section: "settingsrentalagreement",
        sidebarProps: {
          displayText: "Rental Agreement",
        },
      },
      {
        path: "/admin/carrental/returnreceipt",
        element: <ReturnReceipt />,
        state: "carrental.returnreceipt",
        section: "settingsreturnreceipt",
        sidebarProps: {
          displayText: "Return Receipt",
        },
      },
    ],
  },
  {
    path: "/admin/fleet",
    element: <AdminFleet />,
    state: "fleet",
    sidebarProps: {
      displayText: "Fleet",
      icon: 'traffic_jam',
    },
    child: [
      {
        path: "/admin/fleet/fleet",
        element: <FleetSettings />,
        state: "fleet.fleet",
        section: "settingsfleet",
        sidebarProps: {
          displayText: "Fleet",
        },
      },
      {
        path: "/admin/fleet/branches",
        element: <Branches />,
        state: "fleet.branches",
        section: "settingsbranches",
        sidebarProps: {
          displayText: "Branches",
        },
      },
      {
        path: "/admin/fleet/fleetlocations",
        element: <FleetLocations />,
        state: "fleet.fleetlocations",
        section: "settingsfleetlocations",
        sidebarProps: {
          displayText: "Fleet Locations",
        },
      },
      {
        path: "/admin/fleet/relocationMapping",
        element: <RelocationMapping />,
        state: "fleet.relocationmapping",
        section: "settingsrelocationmapping",
        sidebarProps: {
          displayText: "Relocation Mapping",
        },
      },
      {
        path: "/admin/fleet/vehicleclasses",
        element: <VehicleClasses />,
        state: "fleet.vehicleclasses",
        section: "settingsvehicleclasses",
        sidebarProps: {
          displayText: "Vehicle Classes",
        },
      },
      {
        path: "/admin/fleet/vehicletypes",
        element: <VehicleTypes />,
        state: "fleet.vehicletypes",
        section: "settingsvehicletypes",
        sidebarProps: {
          displayText: "Vehicle Types",
        },
      },
      {
        path: "/admin/fleet/vehiclemake",
        element: <VehicleMake />,
        state: "fleet.vehiclemake",
        section: "settingsvehiclemake",
        sidebarProps: {
          displayText: "Vehicle Make",
        },
      },
      {
        path: "/admin/fleet/vehiclemodel",
        element: <VehicleModel />,
        state: "fleet.vehiclemodel",
        section: "settingsvehiclemodel",
        sidebarProps: {
          displayText: "Vehicle Model",
        },
      },
      {
        path: "/admin/fleet/vehicleengines",
        element: <VehicleEngines />,
        state: "fleet.vehicleengines",
        section: "settingsvehicleengines",
        sidebarProps: {
          displayText: "Vehicle Engines",
        },
      },
      {
        path: "/admin/fleet/features",
        element: <Features />,
        state: "fleet.features",
        section: "settingsfeatures",
        sidebarProps: {
          displayText: "Features",
        },
      },
      {
        path: "/admin/fleet/maintenance",
        element: <Maintenance />,
        state: "fleet.maintenance",
        section: "settingsmaintenance",
        sidebarProps: {
          displayText: "Maintenance",
        },
      },
        {
        path: "/admin/fleet/maintenancerules",
        element: <VehicleMaintenanceRules />,
        state: "fleet.maintenancerules",
        section: "settingsmaintenancerules",
        sidebarProps: {
          displayText: "Maintenance Rules",
        },
      },
    ],
  },
  {
    path: "/admin/contacts",
    element: <AdminContacts />,
    state: "contacts",
    section: "settingsadmincontacts",
    sidebarProps: {
      displayText: "Contacts",
      icon: 'contacts',
    },
  },
  {
    path: "/admin/paymentgateways",
    element: <PaymentGateways />,
    state: "paymentgateways",
    sidebarProps: {
      displayText: "Payment Gateways",
      icon: 'payments',
    },
    child: [
      {
        path: "/admin/paymentgateways/settings",
        element: <Settings />,
        state: "paymentgateways.settings",
        section: "settingsforpaymentgateways",
        sidebarProps: {
          displayText: "Settings",
        },
      },
      {
        path: "/admin/paymentgateways/gateways",
        element: <Gateways />,
        state: "paymentgateways.gateways",
        section: "settingsgateways",
        sidebarProps: {
          displayText: "Gateways",
        },
      },
      {
        path: "/admin/paymentgateways/transactions",
        element: <Transactions />,
        state: "paymentgateways.transactions",
        section: "settingstransactions",
        sidebarProps: {
          displayText: "Transactions",
        },
      },
      {
        path: "/admin/paymentgateways/creditcards",
        element: <CreditCards />,
        state: "paymentgateways.creditcards",
        section: "settingscreditcards",
        sidebarProps: {
          displayText: "Credit Cards",
        },
      },
    ],
  },
  {
    path: "/admin/checklist",
    element: <AdminChecklist />,
    state: "checklist",
    section: "settingschecklist",
    sidebarProps: {
      displayText: "Checklist",
      icon: 'fact_check',
    },
  },
  {
    path: "/admin/forms",
    element: <AdminForms />,
    state: "forms",
    section: "settingsforms",
    sidebarProps: {
      displayText: "Forms",
      icon: 'list_alt',
    },
  },
  {
    path: "/admin/accounting",
    element: <Accounting />,
    state: "accounting",
    sidebarProps: {
      displayText: "Accounting",
      icon: 'account_balance_wallet',
    },
    child: [
      {
        path: "/admin/accounting/driver",
        element: <Driver />,
        state: "accounting.driver",
        section: "settingsdriver",
        sidebarProps: {
          displayText: "Driver",

        },
      },
    ],
  },
  {
    path: "/admin/billing",
    element: <Billing />,
    state: "billing",
    section: "settingsbilling",
    sidebarProps: {
      displayText: "Billing",
      icon: 'receipt_long',
    },
  }
];

export default appAdminRoutes;
